module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/@covalent/core/common/styles/font/MaterialIcons-Regular.eot
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.eot
// module chunks = 2